import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TurkishRestaurants from "../pages/turkish-restaurants/page";
import BurgerRestaurants from "../pages/burger-restaurants/page";
import SushiRestaurants from "../pages/sushi-restaurants/page";
import MexicanRestaurants from "../pages/mexican-restaurants/page";
import PizzaRestaurants from "../pages/pizza-restaurants/page";
import FishRestaurants from "../pages/fish-restaurants/page";
import SteakRestaurants from "../pages/steak-restaurants/page";
import KoreanRestaurants from "../pages/korean-restaurants/page";
import PersianRestaurants from "../pages/persian-restaurants/page";
import ItalianRestaurants from "../pages/italian-restaurants/page";
import ChineseRestaurants from "../pages/chinese-restaurants/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/turkish-restaurants",
    element: <TurkishRestaurants />,
  },
  {
    path: "/burger-restaurants",
    element: <BurgerRestaurants />,
  },
  {
    path: "/sushi-restaurants",
    element: <SushiRestaurants />,
  },
  {
    path: "/mexican-restaurants",
    element: <MexicanRestaurants />,
  },
  {
    path: "/pizza-restaurants",
    element: <PizzaRestaurants />,
  },
  {
    path: "/fish-restaurants",
    element: <FishRestaurants />,
  },
  {
    path: "/steak-restaurants",
    element: <SteakRestaurants />,
  },
  {
    path: "/korean-restaurants",
    element: <KoreanRestaurants />,
  },
  {
    path: "/persian-restaurants",
    element: <PersianRestaurants />,
  },
  {
    path: "/italian-restaurants",
    element: <ItalianRestaurants />,
  },
  {
    path: "/chinese-restaurants",
    element: <ChineseRestaurants />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
